<template>
    <div class="col-md-12 ml-auto mr-auto" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-if="isValid('CanAddBank') || isValid('CanEditBank') ">
        <div class="card">
            <div class="card-body">
                <div class="col-lg-12">
                    <div class="tab-content" id="nav-tabContent">
                        <div class="row p-0 DayHeading ">
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                <span v-if="bank.id=='00000000-0000-0000-0000-000000000000'">{{ $t('AddBank.RegisterBankAccount') }}</span>
                                <span v-else>{{ $t('AddBank.RegisterBankAccount') }}</span>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'" style="margin-top:18px;">
                                <!--<a href="javascript:void(0)" class="btn btn-primary btn-sm" v-on:click="openmodel"><i class="fa fa-plus"></i>Add Cheque Book</a>-->
                              
                            </div>
                            
                        </div>
                        <div class="card-body ">
                            <div class="row ">
                                <div v-bind:key="rendered" class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
                                    <label>{{ $t('AddBank.BankCode') }} : <span class="LabelColour"> <span class="LabelColour"> *</span></span></label>
                                    <div v-bind:class="{'has-danger' : $v.bank.code.$error}">
                                        <input readonly class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="$v.bank.code.$model" />
                                        <span v-if="$v.bank.code.$error" class="error">
                                            <span v-if="!$v.bank.code.required"> {{ $t('AddBank.CodeRequired') }}</span>
                                        </span>
                                    </div>
                                </div>

                                <div class="col-sm-4" v-if="english=='true'">
                                    <label>{{ $t('AddBank.BankName') |englishLanguage }} :<span class="LabelColour"> *</span></label>
                                    <div v-bind:class="{'has-danger' : $v.bank.bankName.$error}">
                                        <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="$v.bank.bankName.$model" />
                                        <span v-if="$v.bank.bankName.$error" class="error text-danger">
                                            <span v-if="!$v.bank.bankName.maxLength"> {{ $t('AddBank.BankNameLength') }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-sm-4" v-if="isOtherLang()">
                                    <label>{{ $t('AddBank.BankName') |arabicLanguage }} :<span class="LabelColour"> *</span></label>
                                    <div v-bind:class="{'has-danger' : $v.bank.nameArabic.$error}">
                                        <input class="form-control " v-bind:class="isLeftToRight() ? 'text-left' : 'arabicLanguage'"  v-model="$v.bank.nameArabic.$model" />
                                        <span v-if="$v.bank.nameArabic.$error" class="error text-danger">
                                            <span v-if="!$v.bank.nameArabic.required"> {{ $t('AddBank.NameRequired') }}</span>
                                            <span v-if="!$v.bank.nameArabic.maxLength"> {{ $t('AddBank.BankNameLength') }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-sm-4" >
                                    <label>Short Name :</label>
                                    <div v-bind:class="{'has-danger' : $v.bank.shortName.$error}">
                                        <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="$v.bank.shortName.$model" />
                                        <span v-if="$v.bank.shortName.$error" class="error text-danger">
                                        </span>
                                    </div>
                                </div>
                                <div class="col-sm-4" v-if="english=='true'">
                                    <label>{{ $t('AddBank.AccountName')  |englishLanguage }}:<span class="LabelColour"> *</span></label>
                                    <div v-bind:class="{'has-danger' : $v.bank.accoutName.$error}">
                                        <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="$v.bank.accoutName.$model" />
                                        <span v-if="$v.bank.accoutName.$error" class="error text-danger">
                                            <span v-if="!$v.bank.accoutName.required">  {{ $t('AddBank.NameRequired') }}</span>
                                            <span v-if="!$v.bank.accoutName.maxLength">  {{ $t('AddBank.NameLength') }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-sm-4" v-if="isOtherLang()">
                                    <label>{{ $t('AddBank.AccountName') |arabicLanguage }}:<span class="LabelColour"> *</span></label>
                                    <div v-bind:class="{'has-danger' : $v.bank.accoutNameArabic.$error}">
                                        <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="$v.bank.accoutNameArabic.$model" />
                                        <span v-if="$v.bank.accoutNameArabic.$error" class="error text-danger">
                                            <span v-if="!$v.bank.accoutNameArabic.required">{{ $t('AddBank.AccountRequired') }}</span>
                                        </span>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <label>{{ $t('AddBank.AccountNumber') }}:<span class="LabelColour"> *</span></label>
                                    <div>
                                        <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="$v.bank.accountNumber.$model" />
                                        <span v-if="$v.bank.accountNumber.$error" class="error text-danger">
                                            <span v-if="!$v.bank.accountNumber.required">{{ $t('AddBank.AccountRequired') }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <label>{{ $t('AddBank.IBNNumber') }}:<span class="LabelColour"> *</span></label>
                                    <div v-bind:class="{'has-danger' : $v.bank.ibnNumber.$error}">
                                        <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="$v.bank.ibnNumber.$model" />
                                        <span v-if="$v.bank.ibnNumber.$error" class="error text-danger">
                                            <span v-if="!$v.bank.ibnNumber.required">{{ $t('AddBank.IBNRequired') }}</span>
                                        </span>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <label>{{ $t('AddBank.Reference') }} :</label>
                                    <div>
                                        <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="bank.reference" />
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <label>{{ $t('AddBank.BranchName') }} :<span class="LabelColour"> *</span></label>
                                    <div v-bind:class="{'has-danger' : $v.bank.branchName.$error}">
                                        <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="$v.bank.branchName.$model" />
                                        <span v-if="$v.bank.branchName.$error" class="error text-danger">
                                            <span v-if="!$v.bank.branchName.required">  {{ $t('AddBank.NameRequired') }}</span>
                                            <span v-if="!$v.bank.branchName.maxLength">  {{ $t('AddBank.NameLength') }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <label>{{ $t('AddBank.BranchCode') }} :</label>
                                    <div>
                                        <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="bank.branchCode" />
                                    </div>
                                </div>


                                <div class="col-sm-4">
                                    <label>{{ $t('AddBank.Currency') }}:<span class="LabelColour"> *</span></label>
                                    <div>
                                        <currency-dropdown v-model="bank.currencyId" :values="bank.currencyId">
                                        </currency-dropdown>

                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <label>{{ $t('AddBank.SwiftCode') }}:</label>
                                    <div>
                                        <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="bank.swiftCode" />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <label>{{ $t('AddBank.ContactPerson') }}:</label>
                                    <div>
                                        <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="bank.contactPerson" />

                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <label>{{ $t('AddBank.ContactName') }} :</label>
                                    <div>
                                        <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="bank.contactName" />

                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <label>{{ $t('AddBank.ManagerName') }}:</label>
                                    <div>
                                        <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="bank.managerName" />

                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <label>{{ $t('AddBank.ManagerContactualNumber') }}:</label>
                                    <div>
                                        <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="bank.managerContectualNumber" />

                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <label>{{ $t('AddBank.AccounType') }}:</label>
                                    <div>
                                        <input class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="bank.accounType" />

                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <label>{{ $t('AddBank.Active') }}:</label> <br />
                                    <toggle-button v-model="bank.active" class="pr-2 pl-2 pt-2" color="#3178F6" />
                                </div>

                                <div class="col-sm-12">
                                    <label>{{ $t('AddBank.Location') }} :</label>
                                    <div>
                                        <textarea class="form-control " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'" v-model="bank.location" />

                                    </div>
                                </div>
                                <!--<label class="ml-2">{{ $t('Product.Active') }} :</label> <toggle-button v-model="bank.isActive" class="ml-2" />-->

                            </div>
                        </div>
                    </div>
                    <div v-if="!loading" class=" col-md-12">
                        <button class="btn btn-primary   mr-2" v-bind:disabled="$v.bank.$invalid" v-if="bank.id=='00000000-0000-0000-0000-000000000000' && isValid('CanAddBank') " v-on:click="SaveBank"><i class="far fa-save"></i> {{ $t('AddBank.btnSave') }}</button>
                        <button class="btn btn-primary   mr-2" v-bind:disabled="$v.bank.$invalid" v-if="bank.id!='00000000-0000-0000-0000-000000000000' && isValid('CanEditBank') " v-on:click="SaveBank"><i class="far fa-save"></i> {{ $t('AddBank.btnUpdate') }}</button>
                        <button class="btn btn-danger   mr-2" v-on:click="GoToBank">{{ $t('AddBank.btnClear') }}</button>
                    </div>
                </div>
            </div>
            <chequelistmodel 
                          
                          :show="show"
                          v-if="show"
                          @close="show=false" />
        </div>
    </div>
    <div v-else> <acessdenied></acessdenied></div>

</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'
    import { required, maxLength, requiredIf } from "vuelidate/lib/validators";
    export default ({
        mixins: [clickMixin],
        data: function () {
            return {
                arabic: '',
                english: '',
                show: false,
                value: '',
                active: 'personal',
                rendered: 0,
                bank: {
                    id: '00000000-0000-0000-0000-000000000000',
                    code: '',
                    bankName: '',
                    nameArabic: '',
                    accoutName: '',
                    branchName: '',
                    accountNumber: '',
                    accoutNameArabic: '',
                    branchCode: '',
                    swiftCode: '',
                    ibnNumber: '',
                    currencyId: '',
                    reference: '',
                    shortName: '',
                    active: true,
                },
                loading: false
            }
        },
        validations: {
            bank:
            {
                code: {
                    required,
                    maxLength: maxLength(30)
                },

                bankName: {
                    maxLength: maxLength(200)
                },
                nameArabic: {
                    required: requiredIf((x) => {
                        if (x.bankName == '' || x.bankName == null)
                            return true;
                        return false;
                    }),
                    maxLength: maxLength(200)
                },
                accoutNameArabic: {
                    required: requiredIf((x) => {
                        if (x.accoutName == '' || x.accoutName == null)
                            return true;
                        return false;
                    }),
                    maxLength: maxLength(200)
                },
                accoutName: {
                    maxLength: maxLength(30)
                },
                branchName: {
                    required,
                    maxLength: maxLength(30)
                },
                accountNumber: {
                    required
                },
                ibnNumber: {
                    required
                },
                currencyId: {
                    required
                },
                shortName: {
                    
                }
            }
        },
        methods: {
          
            GoToBank: function () {
                this.$router.push('/Bank');
            },
            SaveBank: function () {

                this.loading = true;
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.$https
                    .post('/Accounting/SaveBank', this.bank, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(response => {
                        root.loading = false
                        root.info = response.data.bpi

                        root.$swal.fire({
                            icon: 'success',
                            title: 'Saved Successfully',
                            showConfirmButton: false,

                            timer: 800,
                            timerProgressBar: true,

                        });
                        root.$router.push('/Bank');
                    })
                    .catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                title: 'Something Went Wrong!',
                                text: error,
                            });

                        root.loading = false
                    })
                    .finally(() => root.loading = false)
            },
            AutoIncrementCode: function () {
                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https
                    .get('/Accounting/BankCode', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                        if (response.data != null) {
                            root.bank.code = response.data;
                            root.rendered++
                        }
                    });
            },
        },
        created: function () {
            this.$emit('input', this.$route.name);

            this.english = localStorage.getItem('English');
            this.arabic = localStorage.getItem('Arabic');
            if (this.$route.query.data == undefined) {
                /*  this.bank.currency = localStorage.getItem('currency');*/
                this.AutoIncrementCode();
            }
            if (this.$route.query.data != undefined) {

                this.bank = this.$route.query.data;
                /* this.bank.currency = localStorage.getItem('currency');*/

            }
        },
        mounted: function () {

        }
    })

</script>